import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Text } from '@beef/ui-kit';
import { I18n } from 'components';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const ServiceTerms = ({
  serviceDescription,
  discountPrice,
  discountPriceWithDate,
  priceWithoutDiscount,
  socketsDescription,
}) => (
  <div className={cn('service')}>
    <div className={cn('service__element')}>
      <Text size="size5-r-s" color="grey50">
        <I18n path="family.serviceTermsNumberLabel" />
      </Text>
      <Text size="size5-r-s">{serviceDescription}</Text>
    </div>
    <div className={cn('service__element')}>
      <Text size="size5-r-s" color="grey50">
        <I18n path="family.serviceTermsCostLabel" />
      </Text>
      <div>
        <Text
          color="grey95"
          size="size5-r-s"
        >
          {discountPrice ? discountPriceWithDate : priceWithoutDiscount}
        </Text>
      </div>
    </div>
    <div className={cn('service__element')}>
      <Text size="size5-r-s" color="grey50">
        <I18n path="family.serviceSocketsLabel" />
      </Text>
      <div>
        <Text size="size5-r-s" tagType="p">{socketsDescription}</Text>
        <Text size="size5-r-s" tagType="p">
          <I18n path="family.sebAndSdbSocketsText" />
        </Text>
      </div>
    </div>
  </div>
);

ServiceTerms.propTypes = {
  serviceDescription: PropTypes.string,
  discountPrice: PropTypes.string,
  discountPriceWithDate: PropTypes.string,
  priceWithoutDiscount: PropTypes.string,
  socketsDescription: PropTypes.string,
};

export { ServiceTerms };
